import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Correlations from './../correlations/index';
import Devices from './../devices/index';
import Config from './../configuration/index';
import Notifications from './../notifications/index';
import NodeVital from './../nodeVitals/index';
import DeviceCatalogue from '../deviceCatalogue/index';
import AlertModification from '../alertModification/index';
import HeartBeat from './../heartbeat/index';
import LandingPage from './../landingPage/index';
import DataExtract from './../dataExtract/index';
import Metrics from './../../routes/components/routes/metrics/index';
import MachineLearning from './../machineLearning/index';
import ProfileAndSettings from 'app/routes/components/routes/ProfileAndSettings/ProfileAndSettings';
import SetThemeColor from 'app/routes/components/routes/AdminPanel/SetThemeColor';
import {connect} from 'react-redux';


const Components = ({match, profileInfo}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/alerts`}/>

            {/*<Route path={`${match.url}/machine-learning`} component={MachineLearning}/>*/}
            <Route path={`${match.url}/correlations`} component={Correlations}/>
            <Route path={`${match.url}/metrics`} component={Metrics}/>
            <Route path={`${match.url}/devices`} component={Devices}/>
            <Route path={`${match.url}/config`} component={Config}/>
            <Route path={`${match.url}/deviceVitals`} component={NodeVital}/>
            <Route path={`${match.url}/deviceCatalogue`} component={DeviceCatalogue}/>
            <Route path={`${match.url}/alerts`} component={AlertModification}/>
            <Route path={`${match.url}/downloadData`} component={DataExtract}/>
            <Route path={`${match.url}/notifications`} component={Notifications}/>
            <Route path={`${match.url}/summary`} component={LandingPage}/>
            <Route path={`${match.url}/heartbeat`} component={HeartBeat}/>
            <Route path={`${match.url}/machineLearning`} component={MachineLearning}/>
            <Route path={`${match.url}/profile-and-settings`} component={ProfileAndSettings}/>
            <Route path={`${match.url}/admin-panel`} component={profileInfo.isAdmin? SetThemeColor: HeartBeat}/>

        </Switch>
    </div>
);

const mapStateToProps = ({profileInfo}) => {
    return {profileInfo}
};

export default connect(mapStateToProps)(Components);



// WEBPACK FOOTER //
// ./app/routes/components/index.js